export const FINGERPRINT_KEY = 'ZIP_FINGERPRINT';
export const FEATURE_FLAGS_KEY = 'ZIP_FEATURE_FLAGS';
export const ENTRY_SOURCE_KEY = 'ZIP_ENTRY_SOURCE';
export const WIDGET_DATA_KEY = 'ZIP_WIDGET_DATA';
